import type { FC } from "react";

import DiabeticIcon from "@/assets/icons/diabetic";
import GeneticIcon from "@/assets/icons/genetic";
import SmokingIcon from "@/assets/icons/smoking";
import StressIcon from "@/assets/icons/stress";
import ToothIcon from "@/assets/icons/tooth";
import ToothBrushIcon from "@/assets/icons/toothbrush";
import type { Risk } from "@/utils/patient";

type RiskIconProps = {
  risk: Risk | "tooth";
  color: string;
};

const RiskIcon: FC<RiskIconProps> = ({ risk, color }) => {
  switch (risk) {
    case "stress":
      return <StressIcon color={color} />;
    case "smoking":
      return <SmokingIcon color={color} />;
    case "diabetic":
      return <DiabeticIcon color={color} />;
    case "geneticTendency":
      return <GeneticIcon color={color} />;
    case "tooth":
      return <ToothIcon color={color} />;
    case "toothbrush":
      return <ToothBrushIcon color={color} />;
  }
};

export default RiskIcon;
